(() => {
  const locale = String(document.documentElement.lang || 'fr').toLowerCase();
  const localeRoot = locale.split('-')[0];
  const localeKey = locale === 'pt-pt' || localeRoot === 'pt' ? 'pt-pt' : localeRoot;

  const sourceFr = {
    text: 'Nous utilisons des cookies pour exécuter ce site web, mesurer le trafic et personnaliser le contenu. Vous pouvez accepter, refuser ou gérer vos préférences à tout moment.',
    privacy_policy_text: 'Politique de confidentialité',
    dialog_title: 'Ce site web utilise des cookies',
    free_watermark_text: 'Propulsé par Consentmo',
    imprint_link_text: 'Mentions légales',
    accept_button_text: 'Accepter',
    do_not_sell_button_text: 'Ne pas vendre ni partager',
    accept_all_button_text: 'Tout accepter',
    reject_all_button_text: 'Tout refuser',
    close_button_text: 'Fermer',
    reject_button_text: 'Refuser',
    dismiss_button_text: 'Fermer',
    accept_selected_button_text: 'Enregistrer les choix',
    strict_cookies_checkbox: 'Nécessaires',
    strict_cookies_text: 'Essentiels au bon fonctionnement du site, ces cookies permettent des fonctionnalités de base telles que la sécurité, la navigation et l’accès aux zones sécurisées. Ils ne peuvent pas être désactivés.',
    analytics_cookies_checkbox: 'Statistiques',
    analytics_cookies_text: 'En collectant des données anonymes, ces cookies nous aident à comprendre comment les visiteurs interagissent avec le site, nous permettant d’améliorer les performances et l’expérience utilisateur.',
    marketing_cookies_checkbox: 'Marketing',
    marketing_cookies_text: 'Ces cookies suivent votre activité sur différents sites pour fournir des publicités personnalisées et un contenu pertinent. Ils aident également à mesurer l’efficacité de nos campagnes marketing.',
    functionality_cookies_checkbox: 'Préférences',
    functionality_cookies_text: 'Ces cookies mémorisent vos choix - tels que les préférences linguistiques ou les informations de connexion - pour offrir une expérience plus personnalisée.',
    popup_header: 'Sélectionnez les types de cookies que vous acceptez',
    popup_description: 'Choisissez les cookies que nous pouvons utiliser. Les cookies nécessaires sont toujours activés. Vous pouvez modifier vos choix à tout moment dans les paramètres des cookies.',
    change_cookies_text: 'Préférences',
    optout_confirmation_message: 'La préférence de refus a été prise en compte',
    youtube_placeholder_title: 'Vidéo YouTube bloquée',
    youtube_placeholder_description: 'Acceptez les cookies marketing pour voir ce contenu',
    last_consent_given_text: 'Dernier consentement donné le {date}',
    show_less_text: 'Afficher moins',
    show_more_text: 'Afficher plus',
    widget_content: 'Paramètres des cookies',
    ame_popup_header: 'Paramètres des cookies',
    read_more_text: 'En savoir plus',
    always_active_text: 'Toujours actif',
    widget_title: 'Vos paramètres de cookies',
    necessary_cookies_alert: 'Les cookies nécessaires sont obligatoires et ne peuvent pas être désactivés. Essentiels au bon fonctionnement du site, ils permettent des fonctionnalités de base telles que la sécurité, la navigation et l’accès aux zones sécurisées.',
    cookie_bar_aria: 'Cookie bar',
    close_aria: 'Close'
  };

  const translations = {
    fr: {
      ...sourceFr,
      cookie_bar_aria: 'Bandeau de cookies',
      close_aria: 'Fermer'
    },
    en: {
      text: 'We use cookies to operate this website, measure traffic and personalize content. You can accept, reject or manage your preferences at any time.',
      privacy_policy_text: 'Privacy policy',
      dialog_title: 'This website uses cookies',
      free_watermark_text: 'Powered by Consentmo',
      imprint_link_text: 'Legal notice',
      accept_button_text: 'Accept',
      do_not_sell_button_text: 'Do not sell or share',
      accept_all_button_text: 'Accept all',
      reject_all_button_text: 'Reject all',
      close_button_text: 'Close',
      reject_button_text: 'Reject',
      dismiss_button_text: 'Close',
      accept_selected_button_text: 'Save choices',
      strict_cookies_checkbox: 'Necessary',
      strict_cookies_text: 'Essential for the website to work properly, these cookies enable basic features such as security, navigation and access to secure areas. They cannot be disabled.',
      analytics_cookies_checkbox: 'Analytics',
      analytics_cookies_text: 'By collecting anonymous data, these cookies help us understand how visitors interact with the website so we can improve performance and user experience.',
      marketing_cookies_checkbox: 'Marketing',
      marketing_cookies_text: 'These cookies track your activity across websites to provide personalized advertising and relevant content. They also help measure the effectiveness of our marketing campaigns.',
      functionality_cookies_checkbox: 'Preferences',
      functionality_cookies_text: 'These cookies remember your choices, such as language preferences or login details, to provide a more personalized experience.',
      popup_header: 'Select the types of cookies you accept',
      popup_description: 'Choose which cookies we can use. Necessary cookies are always enabled. You can change your choices at any time in the cookie settings.',
      change_cookies_text: 'Preferences',
      optout_confirmation_message: 'Your opt-out preference has been saved',
      youtube_placeholder_title: 'YouTube video blocked',
      youtube_placeholder_description: 'Accept marketing cookies to view this content',
      last_consent_given_text: 'Last consent given on {date}',
      show_less_text: 'Show less',
      show_more_text: 'Show more',
      widget_content: 'Cookie settings',
      ame_popup_header: 'Cookie settings',
      read_more_text: 'Learn more',
      always_active_text: 'Always active',
      widget_title: 'Your cookie settings',
      necessary_cookies_alert: 'Necessary cookies are required and cannot be disabled. They are essential for the website to work properly and enable basic features such as security, navigation and access to secure areas.',
      cookie_bar_aria: 'Cookie banner',
      close_aria: 'Close'
    },
    de: {
      text: 'Wir verwenden Cookies, um diese Website zu betreiben, den Datenverkehr zu messen und Inhalte zu personalisieren. Sie können Ihre Auswahl jederzeit akzeptieren, ablehnen oder verwalten.',
      privacy_policy_text: 'Datenschutzerklärung',
      dialog_title: 'Diese Website verwendet Cookies',
      free_watermark_text: 'Bereitgestellt von Consentmo',
      imprint_link_text: 'Impressum',
      accept_button_text: 'Akzeptieren',
      do_not_sell_button_text: 'Nicht verkaufen oder weitergeben',
      accept_all_button_text: 'Alle akzeptieren',
      reject_all_button_text: 'Alle ablehnen',
      close_button_text: 'Schließen',
      reject_button_text: 'Ablehnen',
      dismiss_button_text: 'Schließen',
      accept_selected_button_text: 'Auswahl speichern',
      strict_cookies_checkbox: 'Erforderlich',
      strict_cookies_text: 'Diese Cookies sind für den ordnungsgemäßen Betrieb der Website unerlässlich und ermöglichen grundlegende Funktionen wie Sicherheit, Navigation und den Zugang zu geschützten Bereichen. Sie können nicht deaktiviert werden.',
      analytics_cookies_checkbox: 'Statistik',
      analytics_cookies_text: 'Durch die Erhebung anonymer Daten helfen uns diese Cookies zu verstehen, wie Besucher mit der Website interagieren, damit wir Leistung und Nutzererlebnis verbessern können.',
      marketing_cookies_checkbox: 'Marketing',
      marketing_cookies_text: 'Diese Cookies verfolgen Ihre Aktivitäten auf verschiedenen Websites, um personalisierte Werbung und relevante Inhalte bereitzustellen. Sie helfen außerdem, die Wirksamkeit unserer Marketingkampagnen zu messen.',
      functionality_cookies_checkbox: 'Präferenzen',
      functionality_cookies_text: 'Diese Cookies speichern Ihre Auswahl, etwa Spracheinstellungen oder Anmeldedaten, um ein persönlicheres Erlebnis zu ermöglichen.',
      popup_header: 'Wählen Sie aus, welche Cookie-Arten Sie akzeptieren',
      popup_description: 'Wählen Sie aus, welche Cookies wir verwenden dürfen. Erforderliche Cookies sind immer aktiviert. Sie können Ihre Auswahl jederzeit in den Cookie-Einstellungen ändern.',
      change_cookies_text: 'Präferenzen',
      optout_confirmation_message: 'Ihre Ablehnung wurde gespeichert',
      youtube_placeholder_title: 'YouTube-Video blockiert',
      youtube_placeholder_description: 'Akzeptieren Sie Marketing-Cookies, um diesen Inhalt anzusehen',
      last_consent_given_text: 'Letzte Einwilligung am {date}',
      show_less_text: 'Weniger anzeigen',
      show_more_text: 'Mehr anzeigen',
      widget_content: 'Cookie-Einstellungen',
      ame_popup_header: 'Cookie-Einstellungen',
      read_more_text: 'Mehr erfahren',
      always_active_text: 'Immer aktiv',
      widget_title: 'Ihre Cookie-Einstellungen',
      necessary_cookies_alert: 'Erforderliche Cookies sind vorgeschrieben und können nicht deaktiviert werden. Sie sind für den ordnungsgemäßen Betrieb der Website unerlässlich und ermöglichen grundlegende Funktionen wie Sicherheit, Navigation und den Zugang zu geschützten Bereichen.',
      cookie_bar_aria: 'Cookie-Banner',
      close_aria: 'Schließen'
    },
    es: {
      text: 'Utilizamos cookies para hacer funcionar este sitio web, medir el tráfico y personalizar el contenido. Puede aceptar, rechazar o gestionar sus preferencias en cualquier momento.',
      privacy_policy_text: 'Política de privacidad',
      dialog_title: 'Este sitio web utiliza cookies',
      free_watermark_text: 'Con tecnología de Consentmo',
      imprint_link_text: 'Aviso legal',
      accept_button_text: 'Aceptar',
      do_not_sell_button_text: 'No vender ni compartir',
      accept_all_button_text: 'Aceptar todo',
      reject_all_button_text: 'Rechazar todo',
      close_button_text: 'Cerrar',
      reject_button_text: 'Rechazar',
      dismiss_button_text: 'Cerrar',
      accept_selected_button_text: 'Guardar selección',
      strict_cookies_checkbox: 'Necesarias',
      strict_cookies_text: 'Esenciales para el correcto funcionamiento del sitio web, estas cookies permiten funciones básicas como la seguridad, la navegación y el acceso a zonas seguras. No pueden desactivarse.',
      analytics_cookies_checkbox: 'Estadísticas',
      analytics_cookies_text: 'Al recopilar datos anónimos, estas cookies nos ayudan a comprender cómo interactúan los visitantes con el sitio web para mejorar el rendimiento y la experiencia de usuario.',
      marketing_cookies_checkbox: 'Marketing',
      marketing_cookies_text: 'Estas cookies siguen su actividad en distintos sitios web para ofrecer publicidad personalizada y contenido relevante. También ayudan a medir la eficacia de nuestras campañas de marketing.',
      functionality_cookies_checkbox: 'Preferencias',
      functionality_cookies_text: 'Estas cookies recuerdan sus elecciones, como las preferencias de idioma o los datos de acceso, para ofrecer una experiencia más personalizada.',
      popup_header: 'Seleccione los tipos de cookies que acepta',
      popup_description: 'Elija qué cookies podemos utilizar. Las cookies necesarias están siempre activadas. Puede cambiar su elección en cualquier momento en la configuración de cookies.',
      change_cookies_text: 'Preferencias',
      optout_confirmation_message: 'Se ha guardado su preferencia de rechazo',
      youtube_placeholder_title: 'Vídeo de YouTube bloqueado',
      youtube_placeholder_description: 'Acepte las cookies de marketing para ver este contenido',
      last_consent_given_text: 'Último consentimiento otorgado el {date}',
      show_less_text: 'Mostrar menos',
      show_more_text: 'Mostrar más',
      widget_content: 'Configuración de cookies',
      ame_popup_header: 'Configuración de cookies',
      read_more_text: 'Más información',
      always_active_text: 'Siempre activas',
      widget_title: 'Su configuración de cookies',
      necessary_cookies_alert: 'Las cookies necesarias son obligatorias y no pueden desactivarse. Son esenciales para el correcto funcionamiento del sitio web y permiten funciones básicas como la seguridad, la navegación y el acceso a zonas seguras.',
      cookie_bar_aria: 'Banner de cookies',
      close_aria: 'Cerrar'
    },
    nl: {
      text: 'We gebruiken cookies om deze website te laten werken, het verkeer te meten en inhoud te personaliseren. U kunt uw voorkeuren op elk moment accepteren, weigeren of beheren.',
      privacy_policy_text: 'Privacybeleid',
      dialog_title: 'Deze website gebruikt cookies',
      free_watermark_text: 'Mogelijk gemaakt door Consentmo',
      imprint_link_text: 'Juridische informatie',
      accept_button_text: 'Accepteren',
      do_not_sell_button_text: 'Niet verkopen of delen',
      accept_all_button_text: 'Alles accepteren',
      reject_all_button_text: 'Alles weigeren',
      close_button_text: 'Sluiten',
      reject_button_text: 'Weigeren',
      dismiss_button_text: 'Sluiten',
      accept_selected_button_text: 'Keuzes opslaan',
      strict_cookies_checkbox: 'Noodzakelijk',
      strict_cookies_text: 'Deze cookies zijn essentieel voor de goede werking van de website en maken basisfuncties mogelijk, zoals beveiliging, navigatie en toegang tot beveiligde gedeelten. Ze kunnen niet worden uitgeschakeld.',
      analytics_cookies_checkbox: 'Statistieken',
      analytics_cookies_text: 'Door anonieme gegevens te verzamelen helpen deze cookies ons te begrijpen hoe bezoekers de website gebruiken, zodat we de prestaties en gebruikerservaring kunnen verbeteren.',
      marketing_cookies_checkbox: 'Marketing',
      marketing_cookies_text: 'Deze cookies volgen uw activiteit op verschillende websites om gepersonaliseerde advertenties en relevante inhoud te tonen. Ze helpen ook de doeltreffendheid van onze marketingcampagnes te meten.',
      functionality_cookies_checkbox: 'Voorkeuren',
      functionality_cookies_text: 'Deze cookies onthouden uw keuzes, zoals taalvoorkeuren of inloggegevens, om een persoonlijkere ervaring te bieden.',
      popup_header: 'Selecteer welke soorten cookies u accepteert',
      popup_description: 'Kies welke cookies we mogen gebruiken. Noodzakelijke cookies zijn altijd ingeschakeld. U kunt uw keuzes op elk moment wijzigen in de cookie-instellingen.',
      change_cookies_text: 'Voorkeuren',
      optout_confirmation_message: 'Uw weigeringsvoorkeur is opgeslagen',
      youtube_placeholder_title: 'YouTube-video geblokkeerd',
      youtube_placeholder_description: 'Accepteer marketingcookies om deze inhoud te bekijken',
      last_consent_given_text: 'Laatste toestemming gegeven op {date}',
      show_less_text: 'Minder tonen',
      show_more_text: 'Meer tonen',
      widget_content: 'Cookie-instellingen',
      ame_popup_header: 'Cookie-instellingen',
      read_more_text: 'Meer informatie',
      always_active_text: 'Altijd actief',
      widget_title: 'Uw cookie-instellingen',
      necessary_cookies_alert: 'Noodzakelijke cookies zijn verplicht en kunnen niet worden uitgeschakeld. Ze zijn essentieel voor de goede werking van de website en maken basisfuncties mogelijk, zoals beveiliging, navigatie en toegang tot beveiligde gedeelten.',
      cookie_bar_aria: 'Cookiebanner',
      close_aria: 'Sluiten'
    },
    it: {
      text: 'Utilizziamo i cookie per far funzionare questo sito web, misurare il traffico e personalizzare i contenuti. Puoi accettare, rifiutare o gestire le tue preferenze in qualsiasi momento.',
      privacy_policy_text: 'Informativa sulla privacy',
      dialog_title: 'Questo sito web utilizza i cookie',
      free_watermark_text: 'Fornito da Consentmo',
      imprint_link_text: 'Note legali',
      accept_button_text: 'Accetta',
      do_not_sell_button_text: 'Non vendere né condividere',
      accept_all_button_text: 'Accetta tutto',
      reject_all_button_text: 'Rifiuta tutto',
      close_button_text: 'Chiudi',
      reject_button_text: 'Rifiuta',
      dismiss_button_text: 'Chiudi',
      accept_selected_button_text: 'Salva le scelte',
      strict_cookies_checkbox: 'Necessari',
      strict_cookies_text: 'Essenziali per il corretto funzionamento del sito, questi cookie consentono funzioni di base come sicurezza, navigazione e accesso alle aree protette. Non possono essere disattivati.',
      analytics_cookies_checkbox: 'Statistiche',
      analytics_cookies_text: 'Raccogliendo dati anonimi, questi cookie ci aiutano a capire come i visitatori interagiscono con il sito, permettendoci di migliorare prestazioni ed esperienza utente.',
      marketing_cookies_checkbox: 'Marketing',
      marketing_cookies_text: 'Questi cookie seguono la tua attività su diversi siti per offrire pubblicità personalizzata e contenuti pertinenti. Aiutano inoltre a misurare l’efficacia delle nostre campagne di marketing.',
      functionality_cookies_checkbox: 'Preferenze',
      functionality_cookies_text: 'Questi cookie ricordano le tue scelte, come le preferenze linguistiche o i dati di accesso, per offrire un’esperienza più personalizzata.',
      popup_header: 'Seleziona i tipi di cookie che accetti',
      popup_description: 'Scegli quali cookie possiamo utilizzare. I cookie necessari sono sempre attivi. Puoi modificare le tue scelte in qualsiasi momento nelle impostazioni dei cookie.',
      change_cookies_text: 'Preferenze',
      optout_confirmation_message: 'La tua preferenza di rifiuto è stata salvata',
      youtube_placeholder_title: 'Video YouTube bloccato',
      youtube_placeholder_description: 'Accetta i cookie di marketing per visualizzare questo contenuto',
      last_consent_given_text: 'Ultimo consenso fornito il {date}',
      show_less_text: 'Mostra meno',
      show_more_text: 'Mostra altro',
      widget_content: 'Impostazioni dei cookie',
      ame_popup_header: 'Impostazioni dei cookie',
      read_more_text: 'Scopri di più',
      always_active_text: 'Sempre attivi',
      widget_title: 'Le tue impostazioni dei cookie',
      necessary_cookies_alert: 'I cookie necessari sono obbligatori e non possono essere disattivati. Sono essenziali per il corretto funzionamento del sito e consentono funzioni di base come sicurezza, navigazione e accesso alle aree protette.',
      cookie_bar_aria: 'Banner dei cookie',
      close_aria: 'Chiudi'
    },
    'pt-pt': {
      text: 'Utilizamos cookies para assegurar o funcionamento deste site, medir o tráfego e personalizar o conteúdo. Pode aceitar, recusar ou gerir as suas preferências a qualquer momento.',
      privacy_policy_text: 'Política de privacidade',
      dialog_title: 'Este site utiliza cookies',
      free_watermark_text: 'Fornecido por Consentmo',
      imprint_link_text: 'Aviso legal',
      accept_button_text: 'Aceitar',
      do_not_sell_button_text: 'Não vender nem partilhar',
      accept_all_button_text: 'Aceitar tudo',
      reject_all_button_text: 'Recusar tudo',
      close_button_text: 'Fechar',
      reject_button_text: 'Recusar',
      dismiss_button_text: 'Fechar',
      accept_selected_button_text: 'Guardar escolhas',
      strict_cookies_checkbox: 'Necessários',
      strict_cookies_text: 'Essenciais para o correto funcionamento do site, estes cookies permitem funções básicas como segurança, navegação e acesso a áreas protegidas. Não podem ser desativados.',
      analytics_cookies_checkbox: 'Estatísticas',
      analytics_cookies_text: 'Ao recolher dados anónimos, estes cookies ajudam-nos a compreender como os visitantes interagem com o site, permitindo melhorar o desempenho e a experiência do utilizador.',
      marketing_cookies_checkbox: 'Marketing',
      marketing_cookies_text: 'Estes cookies acompanham a sua atividade em diferentes sites para apresentar publicidade personalizada e conteúdo relevante. Também ajudam a medir a eficácia das nossas campanhas de marketing.',
      functionality_cookies_checkbox: 'Preferências',
      functionality_cookies_text: 'Estes cookies memorizam as suas escolhas, como preferências de idioma ou dados de acesso, para proporcionar uma experiência mais personalizada.',
      popup_header: 'Selecione os tipos de cookies que aceita',
      popup_description: 'Escolha os cookies que podemos utilizar. Os cookies necessários estão sempre ativos. Pode alterar as suas escolhas a qualquer momento nas definições de cookies.',
      change_cookies_text: 'Preferências',
      optout_confirmation_message: 'A sua preferência de recusa foi guardada',
      youtube_placeholder_title: 'Vídeo do YouTube bloqueado',
      youtube_placeholder_description: 'Aceite os cookies de marketing para ver este conteúdo',
      last_consent_given_text: 'Último consentimento dado em {date}',
      show_less_text: 'Mostrar menos',
      show_more_text: 'Mostrar mais',
      widget_content: 'Definições de cookies',
      ame_popup_header: 'Definições de cookies',
      read_more_text: 'Saber mais',
      always_active_text: 'Sempre ativos',
      widget_title: 'As suas definições de cookies',
      necessary_cookies_alert: 'Os cookies necessários são obrigatórios e não podem ser desativados. São essenciais para o correto funcionamento do site e permitem funções básicas como segurança, navegação e acesso a áreas protegidas.',
      cookie_bar_aria: 'Banner de cookies',
      close_aria: 'Fechar'
    }
  };

  const translated = translations[localeKey];
  if (!translated) return;

  const consentmoFields = Object.fromEntries(
    Object.entries(translated).filter(([key]) => !key.endsWith('_aria'))
  );

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';

    if (!requestUrl.includes('app.consentmo.com/users/getCookieConsentSettings') || !response.ok) {
      return response;
    }

    try {
      const payload = await response.clone().json();
      if (!payload || typeof payload !== 'object' || payload.status === 'disabled') return response;

      const headers = new Headers(response.headers);
      headers.delete('content-encoding');
      headers.delete('content-length');

      return new Response(
        JSON.stringify({
          ...payload,
          ...consentmoFields,
          multilingual_enabled: false,
          multilingual_detection_method: 'locale',
          predefined_translation_lang: localeKey,
          data_collection_text_lang: localeKey
        }),
        {
          status: response.status,
          statusText: response.statusText,
          headers
        }
      );
    } catch (_error) {
      return response;
    }
  };

  const replacements = new Map();
  Object.keys(translated).forEach((key) => {
    if (sourceFr[key] && translated[key]) replacements.set(sourceFr[key], translated[key]);
  });

  const replaceValue = (value) => {
    if (!value) return value;
    const trimmed = value.trim();
    const replacement = replacements.get(trimmed);
    if (!replacement) return value;
    return value.replace(trimmed, replacement);
  };

  const translateTree = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode;
    while ((textNode = walker.nextNode())) {
      const nextValue = replaceValue(textNode.nodeValue);
      if (nextValue !== textNode.nodeValue) textNode.nodeValue = nextValue;
    }

    root.querySelectorAll?.('[aria-label], [title], [placeholder]').forEach((element) => {
      ['aria-label', 'title', 'placeholder'].forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const currentValue = element.getAttribute(attribute);
        const nextValue = replaceValue(currentValue);
        if (nextValue !== currentValue) element.setAttribute(attribute, nextValue);
      });
    });
  };

  const observedRoots = new WeakSet();
  const observeConsentmo = () => {
    document.querySelectorAll('csm-cookie-consent, .csm-cookie-consent').forEach((host) => {
      const root = host.shadowRoot || host;
      if (observedRoots.has(root)) return;

      observedRoots.add(root);
      translateTree(root);
      new MutationObserver(() => translateTree(root)).observe(root, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
        attributeFilter: ['aria-label', 'title', 'placeholder']
      });
    });
  };

  const startObserver = () => {
    observeConsentmo();
    new MutationObserver(observeConsentmo).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
